<ng-container *ngIf="vm$ | async as vm">
	<div
		class="flex flex-col items-center py-10 px-16 bg-white rounded border-grey-veryLight border"
		*ngIf="vm.requestSent"
	>
		<img
			src="/assets/images/closer-logos/closer-logo-full.webp"
			alt="Closer"
			class="login-header__logo"
		/>
		<ng-container>
			<h4 class="mt-6 text-center">Thank you for signing up!</h4>
			<p class="mt-6 text-center">
				Once we have confirmed your law firm you will receive an email to start
				setting up your account.
			</p>
			<p class="mt-6 text-center text-sm">
				If you do not receive an email in the next 5 minutes, please contact us
				at
				<a
					emailLinkInterceptor
					href="mailto:support@lawlabs.ca"
					class="underline"
					>support&#64;lawlabs.ca</a
				>
			</p>
		</ng-container>
	</div>

	<app-auth-container
		*ngIf="!vm.requestSent"
		label="Sign up"
		description="Experience the platform designed to carry your firm forward."
		submitButtonText="Sign Up"
		[hideSocials]="true"
		[loading]="vm.loading"
		[formGroup]="authForm"
		[disabled]="vm.loading"
		(onFormSubmit)="submit()"
	>
		<ng-container form-content>
			<app-input
				class="font-light"
				label="Company name"
				[formControlName]="SIGNUP_FORM_FIELDS.COMPANY_NAME"
				type="email"
				[testHook]="testHooks.CompanyName"
			></app-input>

			<app-address
				name="Business Address"
				class="flex-initial"
				[address]="authForm.get(SIGNUP_FORM_FIELDS.ADDRESS).value"
				[disabled]="vm.loading"
				[enableCountrySelect]="false"
				[formControlName]="SIGNUP_FORM_FIELDS.ADDRESS"
				[required]="true"
				[submitted]="vm.submitted"
				[testHook]="testHooks.Address"
				(onAddressUpdate)="setAddress($event)"
			>
			</app-address>

			<div class="border-grey-lighter border-t"></div>

			<app-input
				class="font-light"
				label="First name"
				[formControlName]="SIGNUP_FORM_FIELDS.FIRST_NAME"
				[testHook]="testHooks.FirstName"
			></app-input>
			<app-input
				class="font-light"
				label="Last name"
				[formControlName]="SIGNUP_FORM_FIELDS.LAST_NAME"
				[testHook]="testHooks.LastName"
			></app-input>
			<app-input
				class="font-light"
				label="Email"
				[formControlName]="SIGNUP_FORM_FIELDS.EMAIL"
				type="email"
				[testHook]="testHooks.Email"
			></app-input>
			<app-input
				class="font-light"
				label="Phone Number"
				[formControlName]="SIGNUP_FORM_FIELDS.PHONE_NUMBER"
				[testHook]="testHooks.PhoneNumber"
			></app-input>
		</ng-container>

		<ng-container footer-content>
			<p>Already have an account?</p>
			<app-anchor type="bold" [url]="loginUrl">Log in</app-anchor>
		</ng-container>
	</app-auth-container>
</ng-container>
